<template>
  <section>
    <v-container fluid>
          
      <v-row>
        <v-col md="12">
          <div>
            <h4>
              Filter For Property Data
              <v-icon v-if="!filtersection" @click="toggleFilter">
                mdi-chevron-down </v-icon
              ><v-icon v-if="filtersection" @click="toggleFilter">
                mdi-chevron-up
              </v-icon>
            </h4>
          </div>

          <div>
            <v-switch
              ref="wishlisthBtn"
              class="wishlistBtn"
              :class="{ stickyBtn: stickWishlist }"
              v-model="wishlist"
              :label="`Favourites`"
              @change="filterData"
            ></v-switch>
            <v-form v-if="filtersection">
              <v-row>
                <v-col md="12" class="pt-5"
                  ><strong> Search Criteria </strong>
                </v-col>
                <v-col md="4" class="no-pad-tb">
                  <v-label>Search property with keywords </v-label>
                  <v-text-field
                    class="pt-2"
                    v-model="area"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col md="3" class="no-pad-tb">
                  <v-label>'NW', 'NW3', 'NW3 5TY'</v-label>
                  <v-text-field
                    class="pt-2"
                    v-model="prefixpostcode"
                    label="Postcode"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col md="5" class="no-pad-tb">
                  <v-label>Property Type</v-label>
                  <v-select
                    class="pt-2"
                    :items="propertyTypes"
                    v-model="propertyType"
                    outlined
                    dense
                    multiple
                  >
                  </v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" class="pt-0"
                  ><strong> Number Filter </strong>
                </v-col>
                <v-col md="2" class="no-pad-tb">
                  <v-label>Min Price</v-label>
                  <v-text-field
                    class="pt-2"
                    v-model="minprice"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>

                <v-col md="2" class="no-pad-tb">
                  <v-label>Max Price</v-label>
                  <v-text-field
                    class="pt-2"
                    v-model="maxprice"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col md="2" class="no-pad-tb">
                  <v-label>Min Bed</v-label>
                  <v-text-field
                    class="pt-2"
                    v-model="minbed"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col md="2" class="no-pad-tb">
                  <v-label>Max Bed</v-label>
                  <v-text-field
                    class="pt-2"
                    v-model="maxbed"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col md="2" class="no-pad-tb">
                  <v-label>Min LHA Yield</v-label>
                  <v-text-field
                    class="pt-2"
                    v-model="minLhaYield"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col md="2" class="no-pad-tb">
                  <v-label>Min Rent Yield</v-label>
                  <v-text-field
                    class="pt-2"
                    v-model="minRentYield"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" class="pt-0"
                  ><strong> Flag Filter </strong>
                </v-col>
                <v-col md="2" class="no-pad-tb">
                  <v-label>Sold Stc</v-label>
                  <v-select
                    class="pt-2"
                    :items="soldStcs"
                    v-model="soldstc"
                    outlined
                    item-text="text"
                    item-value="val"
                    dense
                  ></v-select>
                </v-col>
                <v-col md="2" class="no-pad-tb">
                  <v-label>Is Listing Live</v-label>
                  <v-select
                    class="pt-2"
                    :items="isListingLives"
                    v-model="isListing"
                    item-text="text"
                    item-value="val"
                    outlined
                    dense
                  >
                  </v-select>
                </v-col>
                <v-col md="2" class="no-pad-tb">
                  <v-label>Auction</v-label>
                  <v-select
                    class="pt-2"
                    :items="austionProperties"
                    v-model="auctionProperty"
                    outlined
                    item-text="text"
                    item-value="val"
                    dense
                  ></v-select>
                </v-col>
                <v-col md="2" class="no-pad-tb">
                  <v-label>New Build</v-label>
                  <v-select
                    class="pt-2"
                    :items="newbuilds"
                    v-model="newbuild"
                    outlined
                    item-text="text"
                    item-value="val"
                    dense
                  ></v-select>
                </v-col>
                <v-col md="2" class="no-pad-tb">
                  <v-label>Shared Ownership</v-label>
                  <v-select
                    class="pt-2"
                    :items="sharedOwnerships"
                    v-model="sharedOwnership"
                    outlined
                    item-text="text"
                    item-value="val"
                    dense
                  ></v-select>
                </v-col>
                <v-col md="2" class="no-pad-tb">
                  <v-label>Retirement</v-label>
                  <v-select
                    class="pt-2"
                    :items="retirementHomes"
                    v-model="retirementHome"
                    outlined
                    dense
                    item-text="text"
                    item-value="val"
                  ></v-select>
                </v-col>

                <v-col md="2" class="no-pad-tb" v-if="false">
                  <v-label>Door Number</v-label>
                  <v-text-field
                    class="pt-2"
                    v-model="area"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col md="2" class="no-pad-tb">
                  <v-label>Need Refurbishment</v-label>
                  <v-select
                    class="pt-2"
                    :items="needRefurbishments"
                    v-model="needRefurbishment"
                    outlined
                    item-text="text"
                    item-value="val"
                    dense
                  ></v-select>
                </v-col>
                <v-col md="2" class="no-pad-tb">
                  <v-label>Is Park Home</v-label>
                  <v-select
                    class="pt-2"
                    :items="isParkHomes"
                    v-model="isParkHome"
                    outlined
                    item-text="text"
                    item-value="val"
                    dense
                  >
                  </v-select>
                </v-col>

                <v-col md="2" class="no-pad-tb label100">
                  <v-label
                    >Postcode
                    <div
                      class="d-inline-flex justify-space-between btnActReset"
                    >
                      <span class="resetBtn" @click="resetPostcode"
                        >Default</span
                      >
                      <span class="resetBtn" @click="clearPostcode"
                        >Clear All</span
                      >
                    </div>
                  </v-label>
                  <v-select
                    :items="postcodes"
                    v-model="postcodesDefaults"
                    outlined
                    item-text="postcode"
                    item-value="postcode"
                    class="pt-2"
                    multiple
                    dense
                  >
                  </v-select>
                </v-col>
                <v-col md="2" class="no-pad-tb">
                  <v-label>Deal Status</v-label>
                  <v-select
                    :items="propertyStatuses"
                    v-model="propertyStatus"
                    outlined
                    class="pt-2"
                    dense
                  >
                  </v-select>
                </v-col>
                <v-col md="2" class="no-pad-tb">
                  <v-label>Saved Searches</v-label>
                  <v-select
                    :items="searches"
                    v-model="search"
                    outlined
                    item-text="searchName"
                    item-value="searchName"
                    @change="getSeachSingle"
                    class="pt-2"
                    dense
                  >
                  </v-select>
                </v-col>
                <v-col md="2" class="no-pad-tb">
                  <v-label>Listed Date</v-label>
                  <v-select
                    :items="dayAdded"
                    v-model="dayAddedSelected"
                    outlined
                    item-text="title"
                    item-value="day"
                    @change="dateFixer"
                    class="pt-2"
                    dense
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-form>

            <v-col md="12" class="mr-btm d-flex justify-space-between">
              <div>
                <v-btn
                  v-if="!allLoadingDownload"
                  @click="sendEmail"
                  class="leftSec"
                  >Send To Email</v-btn
                >
                <v-btn v-if="allLoadingDownload" class="leftSec"
                  >Sending The Data to your email ...</v-btn
                >
                <v-btn class="ml-5 leftSec" @click="searchPopup"
                  >Save Search</v-btn
                >
              </div>
              <v-btn v-if="filterLoading" loading class="formInside"></v-btn>
              <v-btn class="formInside" @click="filterData">Apply Filter</v-btn>
            </v-col>

            <div v-if="loadingToday">Loading Yesterday's Report</div>
            <div class="" v-if="!loadingToday">
              <ul class="d-flex ulTop">
                <li v-if="allPropertyReport.results.newProperties.length > 0">
                  <h5>
                    No. New Propeties Added On ({{
                      new Date(Date.now() - 24 * 60 * 60 * 1000).getDate()
                    }}/0{{
                      new Date(Date.now() - 24 * 60 * 60 * 1000).getMonth() + 1
                    }}/{{
                      new Date(Date.now() - 24 * 60 * 60 * 1000).getFullYear()
                    }})
                  </h5>
                  <span
                    v-for="(data, index) in allPropertyReport.results
                      .newProperties"
                    :key="index + 'new'"
                  >
                    {{ data.title }} - <strong>{{ data.count }}</strong>
                  </span>
                </li>
                <li
                  v-if="allPropertyReport.results.removedProperties.length > 0"
                >
                  <h5>
                    No. Removed Propeties On ({{
                      new Date(Date.now() - 24 * 60 * 60 * 1000).getDate()
                    }}/0{{
                      new Date(Date.now() - 24 * 60 * 60 * 1000).getMonth() + 1
                    }}/{{
                      new Date(Date.now() - 24 * 60 * 60 * 1000).getFullYear()
                    }})
                  </h5>
                  <span
                    v-for="(data, index) in allPropertyReport.results
                      .removedProperties"
                    :key="index + 'new'"
                  >
                    {{ data.title }} - <strong>{{ data.count }}</strong>
                  </span>
                </li>
                <li
                  v-if="allPropertyReport.results.soldStcProperties.length > 0"
                >
                  <h5>
                    No. Sold STC Propeties On ({{
                      new Date(Date.now() - 24 * 60 * 60 * 1000).getDate()
                    }}/0{{
                      new Date(Date.now() - 24 * 60 * 60 * 1000).getMonth() + 1
                    }}/{{
                      new Date(Date.now() - 24 * 60 * 60 * 1000).getFullYear()
                    }})
                  </h5>
                  <span
                    v-for="(data, index) in allPropertyReport.results
                      .soldStcProperties"
                    :key="index + 'new'"
                  >
                    {{ data.title }} - <strong>{{ data.count }}</strong>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </v-col>

        <v-col md="12" v-if="propertyLoading">
          <Loading />
        </v-col>

        <v-col md="12" v-if="!propertyLoading">
          <section>
            <v-row>
              <v-col md="12">
                <h3 class="table-heading flexBox-space">
                  <span> Property Detail Data </span>

                  <span v-if="!loadingPagination" class="d-flex align-center">
                    Total Properties :
                    {{ allPropertiesCount.results }}
                    <div
                      class="d-flex justify-space-between align-center ml-5"
                      v-if="properties.length != 0"
                    >
                      <v-btn
                        @click="
                          prevPage(allNorthSideDetails.pagination.previous)
                        "
                      >
                        <v-icon> mdi-chevron-left </v-icon>
                        Previous
                      </v-btn>
                      <strong class="pl-3 pr-1" v-if="!filterLoading">
                        {{
                          limit * (allNorthSideDetails.pagination.next - 2) + 1
                        }}
                        -
                        {{ (allNorthSideDetails.pagination.next - 1) * limit }}
                      </strong>
                      <strong class="pl-3 pr-1" v-if="filterLoading">
                        <v-progress-circular
                          indeterminate
                          size="25"
                        ></v-progress-circular>
                      </strong>
                      <v-btn
                        class="ml-3"
                        @click="nextPage(allNorthSideDetails.pagination.next)"
                      >
                        Next
                        <v-icon> mdi-chevron-right </v-icon>
                      </v-btn>
                    </div>
                  </span>
                  <span v-if="loadingPagination">
                    Total Properties :
                    <v-progress-circular
                      indeterminate
                      size="25"
                    ></v-progress-circular
                  ></span>
                </h3>
                <v-simple-table class="tableborder">
                  <thead>
                    <tr>
                      <th>Publish</th>
                      <th>S/N</th>
                      <th width="200">Address</th>
                      <th width="200">Property Link</th>
                      <th class="relRow">Price</th>
                      <th class="relRow">Bedrooms</th>
                      <th class="relRow" width="200">Postcode</th>
                      <th>Listed Date</th>
                      <th class="relRow">Valuation</th>
                      <th>Rent</th>
                      <th class="relRow">
                        Gross Yield
                        <v-icon v-if="yieldSort == undefined">
                          mdi-minus
                        </v-icon>
                        <v-icon v-if="yieldSort == -1"> mdi-arrow-up </v-icon>
                        <v-icon v-if="yieldSort == 1"> mdi-arrow-down </v-icon>
                        <ul class="dropBox">
                          <li @click="changeSortYield(-1)">Highest Yield</li>
                          <li @click="changeSortYield(1)">Lowest Yield</li>
                          <li @click="changeSortYield(undefined)">Default</li>
                        </ul>
                      </th>

                      <th>Status</th>
                      <th>User</th>
                      <th>Max Offer</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="filterLoading">
                    <tr>
                      <td class="text-center" colspan="13">
                        <v-progress-circular
                          indeterminate
                        ></v-progress-circular>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="!filterLoading">
                    <tr v-if="properties.length == 0">
                      <td colspan="14">No Property Found</td>
                    </tr>
                    <tr
                      v-for="(data, index) in allNorthSideDetails.results"
                      :key="index"
                      :class="{ activeTab: indexSeletecd == index }"
                    >
                      <td>
                        <v-switch
                          v-model="data.published"
                          @change="onPublish(data._id)"
                          color="primary"
                        >
                        </v-switch>
                      </td>
                      <td>{{ index + 1 }}</td>

                      <td width="200">
                        {{ data.detailAddress.displayAddress }}
                      </td>
                      <td>
                        <a
                          @click="makeItActive(index)"
                          target="_blank"
                          :href="`https://www.rightmove.co.uk/properties/${data.propertyId}`"
                          >View Listing</a
                        >
                      </td>
                      <td>₤{{ numberFormat(data.price) }}</td>
                      <td>{{ data.bedrooms }}</td>
                      <td>{{ data.postcode }}</td>
                      <td
                        v-if="data.listedDate != undefined"
                        :class="{
                          dateHighlight:
                            getDateTime(data.listedDate) < 14 ||
                            data.listedDate == 'Added today',
                        }"
                      >
                        {{ data.listedDate }}
                      </td>
                      <td v-if="data.listedDate == undefined"></td>
                      <td>₤{{ numberFormat(data.averagePriceValution) }}</td>

                      <td>₤{{ numberFormat(data.averageRent) }}</td>
                      <td>
                        {{
                          data.rentGrossYield != undefined
                            ? data.rentGrossYield
                            : ""
                        }}
                      </td>

                      <td>
                        {{ data.propertyStatus }}
                      </td>
                      <td>
                        {{ data.username != undefined ? data.username : "" }}
                      </td>
                      <td>
                        ₤{{
                          (data.averageRent * 12) / (yieldRequired / 100) >
                          data.averagePriceValution
                            ? numberFormat(data.averagePriceValution)
                            : numberFormat(
                                (data.averageRent * 12) / (yieldRequired / 100)
                              )
                        }}
                      </td>
                      <td width="200">
                        <div class="d-flex flex-column align-start">
                          <v-icon
                            class="editIcon favourite"
                            v-if="data.wishlist"
                            @click="wishlistAct(data)"
                          >
                            mdi-heart
                          </v-icon>
                          <v-icon
                            class="editIcon favouriteO"
                            v-if="!data.wishlist"
                            @click="wishlistAct(data)"
                          >
                            mdi-heart-outline
                          </v-icon>
                          <a
                            :href="`/dashboard/singleProperty/${data._id}`"
                            target="_blank"
                          >
                            <v-icon class="editIcon ml-2"> mdi-eye </v-icon>
                          </a>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot v-if="properties.length != 0">
                    <tr>
                      <td colspan="2">
                        <strong>
                          <span v-if="!loadingPagination">
                            Total Properties :
                            {{ allPropertiesCount.results }}</span
                          >
                          <span v-if="loadingPagination">
                            Total Properties :
                            <v-progress-circular
                              indeterminate
                              size="25"
                            ></v-progress-circular
                          ></span>
                        </strong>
                      </td>
                      <td colspan="9"></td>
                      <td class="iconSection" colspan="3">
                        <div v-if="loadingPagination">
                          <v-progress-circular
                            indeterminate
                            size="25"
                          ></v-progress-circular>
                        </div>
                        <div
                          class="d-flex flexend align-center"
                          v-if="!loadingPagination"
                        >
                          <v-btn
                            @click="
                              prevPage(allNorthSideDetails.pagination.previous)
                            "
                          >
                            <v-icon> mdi-chevron-left </v-icon>
                            Previous
                          </v-btn>
                          <strong class="pl-3 pr-1" v-if="!filterLoading">
                            {{
                              limit *
                                (allNorthSideDetails.pagination.next - 2) +
                              1
                            }}
                            -
                            {{
                              (allNorthSideDetails.pagination.next - 1) * limit
                            }}
                          </strong>
                          <strong class="pl-3 pr-1" v-if="filterLoading">
                            <v-progress-circular
                              indeterminate
                              size="25"
                            ></v-progress-circular>
                          </strong>
                          <v-btn
                            @click="
                              nextPage(allNorthSideDetails.pagination.next)
                            "
                          >
                            Next
                            <v-icon> mdi-chevron-right </v-icon>
                          </v-btn>
                        </div>
                      </td>
                    </tr>
                  </tfoot>
                </v-simple-table>
                <center class="py-5" v-if="loadMore">
                  <v-progress-circular indeterminate></v-progress-circular>
                </center>
              </v-col>
            </v-row>
          </section>
        </v-col>
      </v-row>

      <div class="fixPop" v-if="popSearch">
        <div class="formBox">
          <h1 class="mb-2">Search Name</h1>
          <div class="pb-2">
            <small><i>Please enter the search name</i></small>
          </div>
          <v-text-field
            outlined
            v-model="searchName"
            placeholder="Search Name"
          ></v-text-field>
          <v-btn @click="creatSearch" :disabled="searchName == ''">Save</v-btn>
          <v-btn @click="searchClosePopup" class="ml-5">Close</v-btn>
        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loading from "@/components/dashboard/Loading";
import moment from "moment";
import moment_timezone from "moment-timezone";
export default {
  name: "PropertyRightDetails",
  computed: {
    ...mapGetters([
      "allSpecificMenus",
      "allRightMovesSaleDetail",
      "allPostCodes",
      "allPostCodePrefix",
      "allPrefixPostCode",
      "allRightmoveDownload",
      "allLoadingDownload",
      "allNorthSideDetails",
      "allRegion",
      "allSearches",
      "allSearch",
      "allDashboardControl",
      "allPropertiesCount",
      "allPropertyReport",
    ]),
  },
  components: {
    Loading,
  },

  data() {
    return {
      stickWishlist: false,
      loadingToday: true,
      filterLoading: false,
      rightmoveUrl: "https://www.google.com/embeded",
      indexSeletecd: undefined,
      filtersection: false,
      changePostCode: null,
      changePrefixCode: null,
      changePreCode: null,
      loading: false,
      page: 1,
      limit: 100,
      area: undefined,
      postcode: "",
      bedmins: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "min 10"],
      bedmaxs: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "max 10"],
      minprice: undefined,
      maxprice: undefined,
      minyield: undefined,
      maxyield: undefined,
      propertyTypes: [
        "Detached",
        "Semi-Detached",
        "Terraced",
        "Flat",
        "Bungalow",
        "Land",
      ],
      propertyType: ["Detached", "Semi-Detached", "Terraced", "Bungalow"],
      soldStcs: [
        { text: "All", val: null },
        { text: "Yes", val: true },
        { text: "No", val: false },
      ],
      loadingEmailInquiry: false,
      regions: [
        "North East",
        "North West",
        "East Midlands",
        "West Midlands",
        "London",
        "South East",
        "South West",
        "Scotland",
        "Wales",
        "Northern Ireland",
      ],
      propertyStatuses: [
        "All",
        "Offered",
        "Re-Offered",
        "Accepted",
        "Suitable",
        "Unsuitable",
        "No Longer Available",
      ],
      propertyStatus: undefined,
      postcodes: [],
      postcodesDefaults: [
        "BB",
        "BD",
        "BL",
        "CA",
        "CH",
        "CW",
        "DL",
        "DN",
        "HD",
        "HG",
        "HU",
        "HX",
        "L",
        "LA",
        "LS",
        "M",
        "NE",
        "OL",
        "PR",
        "S",
        "SK",
        "SR",
        "TS",
        "WA",
        "WF",
        "WN",
        "YO",
      ],
      websites: [
        { text: "Zoopla", val: "zoopla" },
        { text: "Rightmove", val: "rightmoves" },
      ],
      region: ["North East", "North West"],
      wishlist: false,
      website: ["rightmoves", "zoopla"],
      soldstc: false,
      retirementHomes: [
        { text: "All", val: null },
        { text: "Yes", val: true },
        { text: "No", val: false },
      ],
      retirementHome: false,
      sharedOwnerships: [
        { text: "All", val: null },
        { text: "Yes", val: true },
        { text: "No", val: false },
      ],
      sharedOwnership: false,
      newbuilds: [
        { text: "All", val: null },
        { text: "Yes", val: true },
        { text: "No", val: false },
      ],
      newbuild: false,
      austionProperties: [
        { text: "All", val: null },
        { text: "Yes", val: true },
        { text: "No", val: false },
      ],
      auctionProperty: false,
      needRefurbishments: [
        { text: "All", val: null },
        { text: "Yes", val: true },
        { text: "No", val: false },
      ],
      isListing: true,
      isListingLives: [
        { text: "All", val: null },
        { text: "Yes", val: true },
        { text: "No", val: false },
      ],
      isParkHomes: [
        { text: "All", val: null },
        { text: "Yes", val: true },
        { text: "No", val: false },
      ],
      dayAdded: [
        {
          title: "All",
          day: 0,
        },
        {
          title: "Last 24 Hours",
          day: 1,
        },
        {
          title: "Last 3 Days",
          day: 3,
        },
        {
          title: "Last 7 Days",
          day: 7,
        },
        {
          title: "Last 14 Days",
          day: 14,
        },
      ],
      dayAddedSelected: 0,
      isParkHome: false,
      needRefurbishment: false,
      maxbed: undefined,
      minbed: undefined,
      filterCondition: {},
      jsondata: [],
      prefixpostcode: undefined,
      prepostcode: undefined,
      minRentYield: undefined,
      minLhaYield: undefined,
      returnMarketSort: undefined,
      averageRentSort: undefined,
      averagePriceValutionSort: undefined,
      distcountMarketSort: undefined,
      yieldSort: -1,
      searches: [],
      search: undefined,
      searchName: "",
      popSearch: false,
      propertyUpdatePop: true,
      yieldRequired: 0,
      commentData: {
        propertyId: "",
        status: false,
      },
      selectedProperty: 0,
      loadMore: false,
      properties: [],
      propertyLoading: true,
      loadingPagination: true,
      paginate: 1,
      listedDate: [],
    };
  },
  watch: {
    async changePostCode(v) {
      this.loading = true;
      await this.getPostCodes({ postcode: v });
      this.loading = false;
    },
    async changePreCode(v) {
      this.loading = true;
      await this.getPrePostCodes({ postcode: v });
      this.loading = false;
    },
    async changePrefixCode(v) {
      this.loading = true;
      await this.getPrefixPostCodes({ postcode: v });
      this.loading = false;
    },
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
  },
  methods: {
    ...mapActions([
      "fetchPaginationPropertyDetails",
      "getRightMovesSalesDetail",
      "actionFuction",
      "getPropertyFilterRigthmoves",
      "getPostCodes",
      "getPrePostCodes",
      "getPrefixPostCodes",
      "getFilterDownload",
      "getNorthSideDetail",
      "getRegion",
      "getPropertyInquiry",
      "addComment",
      "listOfComments",
      "setSearch",
      "getSearch",
      "getSearches",
      "getDashboradControl",
      "propertiesCount",
      "propertyVerfication",
      "propertyReport",
      "getPrePostCodes",
      "postWishlist",
      "postPropertyPost",
    ]),
    numberFormat(givenNumber) {
      let internationalNumberFormat = new Intl.NumberFormat("en-US");
      return internationalNumberFormat.format(givenNumber);
    },
    resetPostcode() {
      this.postcodesDefaults = [
        "BB",
        "BD",
        "BL",
        "CA",
        "CH",
        "CW",
        "DL",
        "DN",
        "HD",
        "HG",
        "HU",
        "HX",
        "L",
        "LA",
        "LS",
        "M",
        "NE",
        "OL",
        "PR",
        "S",
        "SK",
        "SR",
        "TS",
        "WA",
        "WF",
        "WN",
        "YO",
      ];
    },

    clearPostcode() {
      this.postcodesDefaults = [];
    },
    makeItActive(index) {
      this.indexSeletecd = index;
    },
    changeSortYield(data) {
      this.yieldSort = data;
      this.filterData();
    },
    save(date) {
      console.log(moment(new Date(this.date)).format("MM/DD/YYYY"));
    },

    async sendInquiry() {
      this.loadingEmailInquiry = true;
      await this.getPropertyInquiry();
      this.loadingEmailInquiry = false;
    },
    toggleFilter() {
      this.filtersection = !this.filtersection;
    },

    async nextPage(nt) {
      this.filterLoading = true;
      this.jsondata = [];
      if (this.filterCondition) {
        if (this.allPropertiesCount.pagination.next != undefined) {
          await this.getNorthSideDetail({
            ...this.filterCondition,
            limit: this.limit,
            page: nt,
          });
        }
      } else {
        if (this.allPropertiesCount.pagination.next != undefined) {
          await this.getNorthSideDetail({
            limit: this.limit,
            page: nt,
          });
        }
      }
      this.properties = this.allNorthSideDetails.results;
      this.jsondata = [];
      this.filterLoading = false;
    },
    async prevPage(pt) {
      this.filterLoading = true;
      this.jsondata = [];
      if (this.filterCondition) {
        if (this.allNorthSideDetails.pagination.previous != undefined) {
          await this.getNorthSideDetail({
            ...this.filterCondition,
            limit: this.limit,
            page: pt,
          });
        }
      } else {
        if (this.allNorthSideDetails.pagination.previous != undefined) {
          await this.getNorthSideDetail({
            limit: this.limit,
            page: pt,
          });
        }
      }
      this.properties = this.allNorthSideDetails.results;
      this.jsondata = [];
      this.filterLoading = false;
    },

    async handleScroll() {
      let sticky = this.filtersection ? 900 : 300;
      if (window.pageYOffset > sticky) {
        this.stickWishlist = true;
      } else {
        this.stickWishlist = false;
      }
    },

    async filterData() {
      this.filterLoading = true;
      this.loadingToday = true;
      this.loadingPagination = true;
      this.jsondata = [];
      this.filterCondition.prefixpostcode = this.prefixpostcode;

      this.filterCondition.isListingLive = this.isListing;

      if (this.maxbed != undefined) {
        this.filterCondition.maxbed = this.maxbed;
      }

      if (this.propertyStatus != undefined) {
        this.filterCondition.propertyStatus = this.propertyStatus;
      }

      this.filterCondition.wishlist = this.wishlist;

      if (this.area != undefined) {
        this.filterCondition.area = this.area;
      }
      if (this.minbed != undefined) {
        this.filterCondition.minbed = this.minbed;
      }

      if (this.minLhaYield != undefined) {
        this.filterCondition.minLhaYield = this.minLhaYield;
      }
      if (this.minRentYield != undefined) {
        this.filterCondition.minRentYield = this.minRentYield;
      }
      if (this.maxprice != undefined) {
        this.filterCondition.maxprice = this.maxprice;
      }

      if (this.minprice != undefined) {
        this.filterCondition.minprice = this.minprice;
      }

      if (this.propertyType != undefined) {
        this.filterCondition.houseSubtype = this.propertyType;
      }
      if (this.postcodesDefaults.length > 0) {
        this.filterCondition.postcodes = this.postcodesDefaults;
      }
      if (this.website.length > 0) {
        this.filterCondition.website = this.website;
      }

      this.filterCondition.soldstc = this.soldstc;

      this.filterCondition.retirementHome = this.retirementHome;

      this.filterCondition.sharedOwnership = this.sharedOwnership;

      this.filterCondition.newBuild = this.newbuild;

      this.filterCondition.auctionProperty = this.auctionProperty;

      this.filterCondition.needRefurbishment = this.needRefurbishment;

      if (this.listedDate.length > 0) {
        this.filterCondition.listedDate = this.listedDate;
      }

      this.filterCondition.isParkHome = this.isParkHome;
      this.filterCondition.radius = null;
      this.filterCondition.limit = this.limit;
      this.filterCondition.page = 1;

      this.filterCondition.yieldSort = this.yieldSort;

      await this.getNorthSideDetail(this.filterCondition);
      this.filterLoading = false;
      this.properties = this.allNorthSideDetails.results;
      this.countPagination();
    },
    async countPagination() {
      await this.propertiesCount(this.filterCondition);
      this.loadingPagination = false;

      await this.propertyReport({
        region: this.region,
        postcode: this.prefixpostcode,
      });
      this.loadingToday = false;
    },
    async sendEmail() {
      await this.getFilterDownload(this.filterCondition);
    },
    async wishlistAct(ele) {
      ele.wishlist = !ele.wishlist;
      await this.postWishlist({
        propertyId: ele.propertyId,
        propertyFor: "sale",
      });
    },

    searchPopup() {
      this.popSearch = true;
    },
    searchClosePopup() {
      this.popSearch = false;
    },

    getFormatedDate(data) {
      return moment(new Date(data)).format("MM/DD/YYYY");
    },
    getDateTime(timeGoing) {
      // console.log(timeGoing);
      let timeGo;
      if (timeGoing != "Added today") {
        let t = timeGoing.split("/");
        timeGo = this.getFormatedDate(`${t[1]}/${t[0]}/${t[2]}`);
      } else {
        timeGo = this.getFormatedDate(timeGoing);
      }

      // console.log(timeGo);

      let end = moment(moment_timezone(new Date(timeGo), "Europe/London"));
      let now = moment(moment_timezone(new Date(), "Europe/London"));

      var delta = Math.abs(end - now) / 1000;
      // calculate (and subtract) whole days
      var days = Math.floor(delta / 86400);
      delta -= days * 86400;

      // calculate (and subtract) whole hours
      var hours = Math.floor(delta / 3600) % 24;
      delta -= hours * 3600;

      // calculate (and subtract) whole minutes
      var minutes = Math.floor(delta / 60) % 60;
      delta -= minutes * 60;

      // what's left is seconds
      var seconds = delta % 60;

      this.days = days;
      this.hours = hours;
      this.minutes = minutes;
      this.seconds = seconds;
      return days;
    },

    async creatSearch() {
      this.filterData();
      await this.setSearch({
        ...this.filterCondition,
        searchName: this.searchName,
        searchSaveFor: "sale",
      });
      await this.getSearches();
      this.searches = this.allSearches.results;
      this.popSearch = false;
    },
    async getSeachSingle() {
      await this.getSearch(this.search);
      if (this.allSearch.results.minprice != undefined) {
        this.minprice = this.allSearch.results.minprice;
      }
      if (this.allSearch.results.maxprice != undefined) {
        this.maxprice = this.allSearch.results.maxprice;
      }
      if (this.allSearch.results.minbed != undefined) {
        this.minbed = this.allSearch.results.minbed;
      }
      if (this.allSearch.results.maxbed != undefined) {
        this.maxbed = this.allSearch.results.maxbed;
      }
      if (this.allSearch.results.minRentYield != undefined) {
        this.minRentYield = this.allSearch.results.minRentYield;
      }
      if (this.allSearch.results.minLhaYield != undefined) {
        this.minLhaYield = this.allSearch.results.minLhaYield;
      }
      if (this.allSearch.results.auctionProperty != undefined) {
        this.auctionProperty = this.allSearch.results.auctionProperty;
      }
      if (this.allSearch.results.soldstc != undefined) {
        this.soldstc = this.allSearch.results.soldstc;
      }
      if (this.allSearch.results.newbuild != undefined) {
        this.newbuild = this.allSearch.results.newbuild;
      }
      if (this.allSearch.results.sharedOwnership != undefined) {
        this.sharedOwnership = this.allSearch.results.maxbed;
      }
      if (this.allSearch.results.retirementHome != undefined) {
        this.retirementHome = this.allSearch.results.retirementHome;
      }
      if (this.allSearch.results.needRefurbishment != undefined) {
        this.needRefurbishment = this.allSearch.results.needRefurbishment;
      }
      if (this.allSearch.results.isParkHome != undefined) {
        this.isParkHome = this.allSearch.results.isParkHome;
      }
      if (this.allSearch.results.sharedOwnership != undefined) {
        this.sharedOwnership = this.allSearch.results.sharedOwnership;
      }
      if (this.allSearch.results.website != undefined) {
        this.website = this.allSearch.results.website;
      }
      if (this.allSearch.results.houseSubtype != undefined) {
        this.houseSubtype = this.allSearch.results.houseSubtype;
      }
      if (this.allSearch.results.region != undefined) {
        this.region = this.allSearch.results.region;
      }
    },
    async applyVerification(data) {
      let dataSend = {
        limit: this.limit + 50,
        skip: this.allNorthSideDetails.pagination.next - 1,
        region: data,
      };
      if (this.prefixpostcode != undefined) {
        dataSend.postcode = this.prefixpostcode;
      }
      await this.propertyVerfication(dataSend);
    },
    dateFixer() {
      const now = new Date();
      let datesBox = [];
      if (this.dayAddedSelected == 1) {
        datesBox.push(
          moment(
            new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1)
          ).format("DD/MM/YYYY")
        );
        this.listedDate = datesBox;
      } else if (this.dayAddedSelected == 3) {
        for (let i = 1; i <= 3; i++) {
          datesBox.push(
            moment(
              new Date(now.getFullYear(), now.getMonth(), now.getDate() - i)
            ).format("DD/MM/YYYY")
          );
        }
        this.listedDate = datesBox;
      } else if (this.dayAddedSelected == 7) {
        for (let i = 1; i <= 7; i++) {
          datesBox.push(
            moment(
              new Date(now.getFullYear(), now.getMonth(), now.getDate() - i)
            ).format("DD/MM/YYYY")
          );
        }
        this.listedDate = datesBox;
      } else if (this.dayAddedSelected == 14) {
        for (let i = 1; i <= 14; i++) {
          datesBox.push(
            moment(
              new Date(now.getFullYear(), now.getMonth(), now.getDate() - i)
            ).format("DD/MM/YYYY")
          );
        }
        this.listedDate = datesBox;
      } else {
        this.listedDate = [];
      }
    },
    onPublish(id) {
      confirm("Are you sure you want to publish this property?") &&
        this.postPropertyPost({
          _id: id,
          propertyFrom: "liveProperty",
        });
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  async created() {
    await this.getPrePostCodes();
    this.postcodes = this.allPostCodePrefix.results;
    await this.filterData();
    this.propertyLoading = false;
    await this.getDashboradControl({ title: "yieldRequired" });
    this.yieldRequired = this.allDashboardControl.results.value;
    await this.getSearches("sale");
    this.searches = this.allSearches.results;
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.dateHighlight {
  background: yellow;
}
.no-pad-tb {
  padding-top: 0;
  padding-bottom: 0;
}
h4 {
  margin-bottom: 0;
}
.v-icon {
  font-size: 16px;
  cursor: pointer;
}
.downloadbtn {
  margin-left: 20px;
}
.fixBoxTop {
  position: fixed;
  top: 20px;
  z-index: 99999;
}
.sub-menus {
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 20px;
  padding-left: 0;
  li {
    a {
      display: block;
      padding: 10px 20px;
      text-decoration: none;
      box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1);
      margin-right: 10px;
      color: $dark;
      background: $white;
      border-radius: 5px;
      // color: $white;
    }
  }
}
.heightZero {
  height: 0;
}
.actionbtn {
  margin-bottom: 20px;
}
.activeTab {
  background: rgb(195, 195, 196);
  color: rgb(20, 20, 20);
  a {
    color: rgb(5, 5, 5);
  }
}
.mr-btm {
  margin-bottom: 30px;
  margin-top: -40px;
}
a {
  text-decoration: none;
}
.mr-left {
  margin-left: 10px;
}
.dropdownlist {
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  margin: 0;
  padding: 8px 0;
  margin-top: -30px;
  li {
    list-style: none;
    padding: 8px 20px;
  }
}
.wishlistBtn {
  position: fixed;
  top: 0px;
  right: 370px;
  z-index: 999;
  transition: 0.3s all ease-in-out;
}

.dropBox {
  list-style: none;
  padding-left: 0;
  position: absolute;
  background: #fff;
  box-shadow: 0 5px 10px #efefef;
  li {
    padding: 10px 25px;
    border-bottom: 1px solid #dfdddd;
    cursor: pointer;
    &:last-of-type {
      border: none;
    }
  }
}
.relRow {
  position: relative;
  .dropBox {
    position: absolute;
    width: 150px;
    display: none;
  }
  &:hover {
    .dropBox {
      display: block;
    }
  }
}
.fixPop {
  background: rgba(0, 0, 0, 0.2);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: fixed;
  justify-content: center;
  z-index: 99999;

  .v-form {
    width: 500px;
  }
  .formBox {
    background: #fff;
    border-radius: 10px;
    width: 550px;
    padding: 30px;
    margin: 0 auto;
    margin-top: 50px;
    position: relative;
    font-size: 14px;
    .mdi-close {
      position: absolute;
      right: 20px;
      top: 15px;
    }
  }
}
.rightmovePopup {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  iframe {
    width: 500px;
    height: 500px;
  }
}
.flexBox-space {
  display: flex;
  justify-content: space-between;
}
.iconSection {
  .v-icon {
    font-size: 30px;
  }
}

.dash {
  font-size: 20px;
  font-weight: 600;
  display: block;
}

.d-flex {
  .justify-space-between {
    span {
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;
    }
  }
}
.flexend {
  justify-content: flex-end;
  .v-btn {
    margin-left: 10px;
  }
}

.ulTop {
  list-style: none;
  padding-left: 0;
  width: 100%;
  padding-top: 10px;
  h5 {
    font-size: 16px;
    margin-bottom: 5px;
    @media only screen and (max-width: 1369px) {
      font-size: 13px;
    }
  }
  margin-bottom: 20px;
  li {
    box-shadow: 0 3px 5px #efefef;
    padding: 20px 40px;
    margin-right: 15px;
    width: 100%;
    span {
      font-size: 14px;
      display: block;
      padding: 5px 0;
      @media only screen and (max-width: 1369px) {
        font-size: 12px;
      }
    }
  }
}
.btnActReset {
  width: 90px;
}

.resetBtn {
  color: blue;
  font-weight: 500;
  &:hover {
    cursor: pointer;
  }
}
.filterBtn {
  position: fixed;
  right: 20px;
  border-radius: 50%;
  min-height: 60px;
  width: 50px;
  bottom: 50px;
}
.formInside {
  margin: 0;
  z-index: 999999;
  width: 150px !important;
  right: 200px;
  top: 15px;
  position: fixed;
}

.leftSec {
  margin: 0;
  z-index: 999999;
  position: fixed;
  top: 15px !important;
  width: 150px !important;
  &:nth-of-type(1) {
    left: 280px;
  }
  &:nth-of-type(2) {
    left: 420px;
  }
}
.favourite {
  color: red;
  width: 35px;
  height: 35px;
}
.favouriteO {
  width: 35px;
  height: 35px;
}
</style>
